import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentGreenComponent } from './payment-green/payment-green.component';
import {RouterModule, Routes} from '@angular/router';
import {StellantisLayoutComponent} from '../stellantis-layout/stellantis-layout.component';
import {NbButtonModule, NbCardModule} from '@nebular/theme';
import {SubscriptionDialogComponent} from './subscription-dialog.component';
import {MatButtonModule} from '@angular/material/button';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {FormsModule} from '@angular/forms';
import {MatFormFieldModule} from '@angular/material/form-field';
import {AcceptTermsComponent} from './accept-terms/accept-terms.component';
import {MatInputModule} from '@angular/material/input';
import {FlexModule} from '@angular/flex-layout';
import {TranslateModule} from '@ngx-translate/core';


const routes: Routes = [
  { path: '', component: PaymentGreenComponent }
];

@NgModule({
  declarations: [
    PaymentGreenComponent,
    SubscriptionDialogComponent,
    AcceptTermsComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    NbCardModule,
    NbButtonModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    FlexModule,
    TranslateModule
  ],
  exports: [RouterModule]
})
export class PaymentModule { }
